// src/services/ganttService.ts
import { apiService } from './api';

class GanttService
{
  /**
   * Get Gantt data (conversations with layers/dates).
   * Returns an object with a `promise` and a `cancel` function to abort.
   */
  static getGantt(request: any): { promise: Promise<any>; cancel: () => void }
  {
    const controller = new AbortController();
    const promise = apiService.post<any>('Conversation/GetConversationGantt', request, {
      signal: controller.signal,
    });
    return {
      promise,
      cancel: () => controller.abort(),
    };
  }

  /**
   * Get basic-field values by BasicFieldId (used for Status dropdown options).
   */
  static GetBasicFieldValueById(basicFieldId: number): Promise<any>
  {
    return apiService.get<any>(
      `BasicFieldValue/GetBasicFieldValueById?BasicFieldId=${basicFieldId}`,
    );
  }

  /**
   * Update an existing custom field value (PUT).
   */
  static save(request: any): Promise<any>
  {
    return apiService.put<any>('customfieldvalue/', request);
  }

  /**
   * Create a new custom field value (POST).
   */
  static savePost(request: any): Promise<any>
  {
    return apiService.post<any>('customfieldvalue/', request);
  }

  /**
   * Get dashboard information by ID.
   */
  static getDashboardInformationById(id: number): Promise<any>
  {
    return apiService.get<any>(`dashboard/?id=${id}`);
  }
}

export default GanttService;
